export const enum DateTimeFormat {
    DATE = 'YYYY-MM-DD',
    LONG_TIME = 'HH:mm:ss',
    SHORT_TIME = 'HH:mm',
    DATE_LONG_TIME = 'YYYY-MM-DD HH:mm:ss',
    DATE_SHORT_TIME = 'YYYY-MM-DD HH:mm',
}
export default DateTimeFormat;
